import React from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const DetailPageSublayout = (props) => <Placeholder name="rotary-detailpage" rendering={props.rendering} />;

export default withSitecoreContext()(DetailPageSublayout);